import api from './api';

const expenseRequestService = {
  getRequest: async (id) => (await api.get(`/expense-requests/${id}`)).data,
  getCaptureContext: async () => (await api.get('/expense-requests/capture-context')).data,
  checkDuplicates: async (fields) => (await api.post('/expense-requests/duplicate-check', {
    amount: fields.amount, currency: fields.currency, expense_date: fields.expense_date,
    vendor_name: fields.vendor_name || '', invoice_number: fields.invoice_number || ''
  })).data,
  getRequests: async (params = {}) => {
    const response = await api.get('/expense-requests', { params });
    return response.data;
  },

  createRequest: async (formData) => {
    const response = await api.post('/expense-requests', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response.data;
  },

  updateRequest: async (id, formData) => {
    const response = await api.put(`/expense-requests/${id}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response.data;
  },

  deleteRequest: async (id) => {
    const response = await api.delete(`/expense-requests/${id}`);
    return response.data;
  },

  getRequestFile: async (requestId, fileId, { download = false } = {}) => {
    const suffix = download ? '/download' : '';
    const response = await api.get(`/expense-requests/${requestId}/files/${fileId}${suffix}`, {
      responseType: 'blob'
    });
    return response;
  },

  getComments: async (requestId) => {
    const response = await api.get(`/expense-requests/${requestId}/comments`);
    return response.data;
  },

  addComment: async (requestId, comment) => {
    const response = await api.post(`/expense-requests/${requestId}/comments`, { comment });
    return response.data;
  },

  deleteComment: async (requestId, commentId) => {
    const response = await api.delete(`/expense-requests/${requestId}/comments/${commentId}`);
    return response.data;
  }
};

export default expenseRequestService;
